import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RecoilRoot, useRecoilSnapshot } from 'recoil';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

// === Configuration Flags ===
// const ENABLE_STRICT_MODE = false;
const ENABLE_STRICT_MODE = true;
const isProd = process.env.NODE_ENV === 'production' || process.env.REACT_APP_NODE_ENV === 'production';

// === Suppress console output in production ===
if (isProd) {
    ['log', 'info', 'warn', 'error'].forEach((method) => {
        console[method] = () => {
            /* empty */
        };
    });
}

// === Debug Observer (only in development) ===
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function DebugObserver() {
    const snapshot = useRecoilSnapshot();
    React.useEffect(() => {
        console.debug('Modified atoms:');
        for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
            console.log('[OBS]:', node.key, snapshot.getInfo_UNSTABLE(node));
        }
    }, [snapshot]);

    return <></>;
}

// === App Root ===
const AppWithRecoil = () => (
    <RecoilRoot>
        <App />
    </RecoilRoot>
);

// === Bootstrap Application ===
const container = document.getElementById('root');
if (!container) throw new Error('Root container missing in index.html');

const root = createRoot(container);

root.render(
    ENABLE_STRICT_MODE ? (
        <StrictMode>
            <AppWithRecoil />
        </StrictMode>
    ) : (
        <AppWithRecoil />
    )
);

// === Service Worker ===
// To enable offline capabilities, change to: serviceWorker.register();
serviceWorker.unregister();
